import React, { Component } from 'react';
import * as Constants from '../../../../utilities/constants/Constants';
import { ProductCard } from '../ProductCard/ProductCard';
import './ProductList.scss';
import { string } from '../../../../localization';
import MultiCanvasPopover from './MultiCanvasPopover';
import { Icons } from '../../../../utilities';

class ProductList extends Component {
  constructor() {
    super();
    this.state = {
      redraw: false
    };
  }

  componentDidMount() {
    this.redraw();
    document.addEventListener('keydown', this.handleUpDownArrowKey);
  }

  componentDidUpdate(prevProps) {
    const { query } = this.props;
    if (prevProps.query !== query) {
      this.redraw();
    }
  }

  componentWillUnmount() {
    const {
      multiCanvasPopoverStatus,
      closeMultiCanvasPopover,
      isCanvas
    } = this.props;
    document.removeEventListener('keydown', this.handleUpDownArrowKey);
    if (isCanvas()) {
      if (multiCanvasPopoverStatus) {
        closeMultiCanvasPopover();
      }
    }
  }

  redraw = () => {
    const { redraw } = this.state;
    this.setState({ redraw: !redraw });
  };

  handleUpDownArrowKey = event => {
    if (event.keyCode === 38) {
      this.onScrollUp();
    } else if (event.keyCode === 40) {
      this.onScrollDown();
    }
  };

  onScrollUp = () => {
    this.getElement('scroll-product-list').scrollTop -= 130;
  };

  onScrollDown = () => {
    this.getElement('scroll-product-list').scrollTop += 130;
  };

  onScrollRight = id => {
    const element = this.getElement(id);
    const topPos = element.offsetWidth;
    element.scrollLeft -= topPos;
    this.redraw();
  };

  onScrollLeft = id => {
    const element = this.getElement(id);
    const topPos = element.offsetWidth;
    const temp = element.scrollLeft;
    element.scrollLeft = temp + topPos;
    this.redraw();
  };

  getElement = id => {
    if (id && document.getElementById(id)) {
      return document.getElementById(id);
    }
    return null;
  };

  isOverflowing = element => {
    if (element) {
      return element.scrollWidth > element.offsetWidth;
    }
    return false;
  };

  alertOverflow = element => {
    if (this.isOverflowing(element)) {
      return true;
    }
    return false;
  };

  handleNextArrowVisibility = id => {
    const element = this.getElement(id);
    if (
      this.alertOverflow(element) &&
      element.scrollLeft < element.scrollWidth - element.offsetWidth
    ) {
      return true;
    }
    return false;
  };

  handlePrevArrowVisibility = id => {
    const element = this.getElement(id);
    if (this.alertOverflow(element)) {
      if (element.scrollLeft > 0) {
        return true;
      }
    }
    return false;
  };

  handleShowAll = family => {
    const { completeProductList, pageController } = this.props;
    const list = this.getcompleteProductList(family);
    completeProductList(list);
    pageController(Constants.PRODUCT_LIST_PAGE);
  };

  getcompleteProductList = familyName => {
    const { data } = this.props;
    let completeProductList;
    data.forEach(element => {
      if (element[0].laptopFamily == familyName) {
        completeProductList = element;
      }
    });
    return completeProductList;
  };

  onScroll = () => {
    this.redraw();
  };

  render() {
    const {
      data,
      isSingleFamilyModels,
      searchResult,
      setSelectedProduct,
      handleSingleProduct,
      singleProductNavigation,
      isTurkeyLaptop,
      isCanvas,
      handleMultiCanvasPopover,
      multiCanvasPopoverStatus,
      IconUrl
    } = this.props;
    const isSingle = handleSingleProduct(data);
    if (isSingle) {
      singleProductNavigation(data);
    }
    if (isSingleFamilyModels()) {
      this.handleShowAll(searchResult[0][0].laptopFamily);
    }

    const multiCanvas = {
      name: 'Multi Canvas',
      productIconUrl: Icons.multiCanvasDesigner,
      productSizes: []
    };

    return (
      <div className='procuct-List-container' id='scroll-product-list'>
        {searchResult.length > 0
          ? searchResult
              .sort((a, b) => (a[0].laptopFamily > b[0].laptopFamily ? 1 : -1))
              .map(item => (
                <div className='position-relative'>
                  {!isCanvas() ? (
                    <span
                      role='button'
                      tabIndex='0'
                      className='d-flex justify-content-between product-title-container'
                      onClick={() => this.handleShowAll(item[0].laptopFamily)}
                      onKeyPress={() => {}}
                    >
                      <div className='d-flex align-items-center'>
                        <div className='group-name'>
                          {item[0].laptopFamily === ''
                            ? 'Others'
                            : item[0].laptopFamily}
                        </div>
                      </div>
                      {this.alertOverflow(
                        this.getElement(item[0].laptopFamily)
                      ) ? (
                        <button
                          type='button'
                          className='helper-text'
                          style={{ border: 'none', background: 'none' }}
                          onClick={() => this.handleShowAll(item)}
                        >
                          {' '}
                          {string.SHOW_ALL_KEY}
                        </button>
                      ) : null}
                    </span>
                  ) : null}

                  <div
                    className='Product-list'
                    id={item[0].laptopFamily}
                    onScroll={e => this.onScroll(e)}
                  >
                    {item.map(productItem => (
                      <ProductCard
                        item={productItem}
                        clickHandler={setSelectedProduct}
                        isWhiteBackground={isTurkeyLaptop}
                        IconUrl={IconUrl}
                      />
                    ))}
                    {isCanvas() ? (
                      <>
                        <ProductCard
                          item={multiCanvas}
                          clickHandler={handleMultiCanvasPopover}
                          isWhiteBackground={isTurkeyLaptop}
                        />
                        <MultiCanvasPopover
                          multiCanvasPopoverStatus={multiCanvasPopoverStatus}
                          // handleMultiCanvasPopover={handleMultiCanvasPopover}
                        />
                      </>
                    ) : null}

                    {this.handleNextArrowVisibility(item[0].laptopFamily) ? (
                      <button
                        type='button'
                        className='arrow arrow-next'
                        style={{ border: 'none', background: 'none' }}
                        onClick={() => this.onScrollLeft(item[0].laptopFamily)}
                      >
                        {'>'}
                      </button>
                    ) : null}
                    {this.handlePrevArrowVisibility(item[0].laptopFamily) ? (
                      <button
                        type='button'
                        className='arrow arrow-prev'
                        style={{ border: 'none', background: 'none' }}
                        onClick={() => this.onScrollRight(item[0].laptopFamily)}
                      >
                        {'<'}
                      </button>
                    ) : null}
                  </div>
                </div>
              ))
          : null}
      </div>
    );
  }
}

export default ProductList;
